"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getLeadinConfig;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _getQueryString = _interopRequireDefault(require("./getQueryString"));

var cachedQueryString;
var LEADIN_CONFIG = 'LEADIN_CONFIG';
var leadinConfigKeys = {
  l: 'language',
  php: 'phpVersion',
  wp: 'wpVersion',
  v: 'leadinPluginVersion',
  theme: 'theme',
  admin: 'admin'
};

function getLeadinConfig() {
  try {
    if (cachedQueryString) {
      return cachedQueryString;
    }

    var queryParams = {};

    try {
      queryParams = JSON.parse(sessionStorage.getItem(LEADIN_CONFIG)) || {};
    } catch (e) {//
    }

    var search = (0, _getQueryString.default)();
    var pairs = search.slice(1).split('&');
    pairs.forEach(function (pair) {
      var _pair$split = pair.split('='),
          _pair$split2 = (0, _slicedToArray2.default)(_pair$split, 2),
          key = _pair$split2[0],
          value = _pair$split2[1];

      if (leadinConfigKeys.hasOwnProperty(key)) {
        queryParams[leadinConfigKeys[key]] = decodeURIComponent(value || '');
      }
    });
    cachedQueryString = queryParams;

    try {
      sessionStorage.setItem(LEADIN_CONFIG, JSON.stringify(queryParams));
    } catch (e) {//
    }

    return queryParams;
  } catch (e) {
    return {};
  }
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hubspot-plugin-common/static-1.186/js/getLeadinConfig.js
// module id = 187
// module chunks = 5 6 7